import { render, staticRenderFns } from "./PublicExamAnswers.vue?vue&type=template&id=65967033"
import script from "./PublicExamAnswers.vue?vue&type=script&lang=js"
export * from "./PublicExamAnswers.vue?vue&type=script&lang=js"
import style0 from "./PublicExamAnswers.vue?vue&type=style&index=0&id=65967033&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports